module.exports = __webpack_public_path__ + "img/Dantam Hair 38.38332f50.jpg";